import { useRef } from "react";
import { useReveal } from "../../lib/reveal";

const ORC_LINK = "https://mautic.remindbrindes.com.br/metiercomlporc1";

const items = [
  {
    type: "video",
    src: "/cases/cafeteiras.mp4",
    poster: "/cases/cafeteira-poster.jpg",
    tag: "EXPERIÊNCIA MARCANTE",
    title: "Material promocional impactante, que eleva a sua marca a outro patamar.",
  },
  {
    type: "video",
    src: "/cases/boasvindas.mp4",
    poster: "/cases/boasvindas-poster.jpg",
    tag: "AMPLIE A SUA PARTICIPAÇÃO",
    title: "Explorar os diferenciais com foco em ampliar a conquista de novos negócios.",
  },
  {
    type: "video",
    src: "/cases/tecnologia.mp4",
    poster: "/cases/tecnologia-poster.jpg",
    tag: "PRESENÇA MAIOR NA VIDA DO CLIENTE",
    title: "Sedimentar a sua marca no dia a dia dos clientes.",
  },
  {
    type: "video",
    src: "/cases/bebidas.mp4",
    poster: "/cases/bebidas-poster.jpg",
    tag: "PERCEPÇÃO DE MAIOR VALOR",
    title: "Construir uma maior reputação e ampliar a força da sua marca.",
  },
];

export default function Cases() {
  const { ref, visible } = useReveal();
  const refs = useRef([]);

  const handleEnter = (i) => {
    refs.current.forEach((v, idx) => {
      if (!v) return;
      if (idx === i) {
        v.currentTime = 0;
        const p = v.play();
        if (p && typeof p.catch === "function") p.catch(() => {});
      } else {
        v.pause();
        try { v.currentTime = 0; } catch (e) {}
      }
    });
  };

  const handleLeave = (i) => {
    const v = refs.current[i];
    if (v) {
      v.pause();
      try { v.currentTime = 0; } catch (e) {}
    }
  };

  return (
    <section
      id="cases"
      ref={ref}
      data-testid="cases-section"
      className="py-24 md:py-32"
      style={{ backgroundColor: "#FAFAFA" }}
    >
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <div className={`flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14 md:mb-20 reveal ${visible ? "in" : ""}`}>
          <div className="max-w-3xl">
            <p className="overline">Ideias em movimento</p>
            <h2 className="font-serif font-light text-4xl md:text-5xl lg:text-6xl tracking-tight text-[#1C1C1C] mt-6 leading-[1.05]">
              Ideias que <em className="italic text-[#556052]">inspiram</em> mais negócios.
            </h2>
          </div>
          <p className="text-sm md:text-base text-[#556052] font-light max-w-sm">
            Passe o mouse sobre cada peça e veja o kit ganhar vida. Uma amostra do que produzimos
            para mentores, produtores de curso e marcas que entendem o poder da experiência física.
          </p>
        </div>

        <div className={`flex flex-col gap-12 md:gap-16 reveal ${visible ? "in" : ""}`}>
          {items.map((it, i) => (
            <figure
              key={i}
              data-testid={`case-card-${i}`}
              className="group relative"
              onMouseEnter={() => it.type === "video" && handleEnter(i)}
              onMouseLeave={() => it.type === "video" && handleLeave(i)}
            >
              <div className="relative overflow-hidden aspect-[16/9] bg-[#0B2E24]">
                {it.type === "video" ? (
                  <>
                    <img
                      src={it.poster}
                      alt={it.tag}
                      className="absolute inset-0 w-full h-full object-cover transition-opacity duration-500 group-hover:opacity-0 pointer-events-none"
                    />
                    <video
                      ref={(el) => (refs.current[i] = el)}
                      src={it.src}
                      poster={it.poster}
                      muted
                      loop
                      playsInline
                      preload="metadata"
                      data-testid={`case-video-${i}`}
                      className="absolute inset-0 w-full h-full object-cover"
                    />
                    <div className="absolute bottom-4 right-4 z-10 bg-[#0B2E24]/85 text-[#FAFAFA] text-[0.65rem] tracking-[0.18em] uppercase px-3 py-2 backdrop-blur-sm opacity-100 group-hover:opacity-0 transition-opacity duration-300">
                      Passe o mouse
                    </div>
                  </>
                ) : (
                  <img
                    src={it.poster}
                    alt={it.tag}
                    className="absolute inset-0 w-full h-full object-cover"
                  />
                )}
              </div>
              <figcaption className="mt-6 flex flex-col md:flex-row md:items-start md:justify-between gap-4">
                <div className="max-w-3xl">
                  <p className="overline text-[#C5A059]">{it.tag}</p>
                  <h3 className="font-serif text-2xl md:text-3xl text-[#1C1C1C] mt-3 leading-snug font-light">
                    {it.title}
                  </h3>
                </div>
                <span className="font-mono text-xs text-[#556052] shrink-0 md:pt-2">
                  0{i + 1} / 0{items.length}
                </span>
              </figcaption>
            </figure>
          ))}
        </div>

        <div className="mt-16 md:mt-20 text-center">
          <a
            href={ORC_LINK}
            target="_blank"
            rel="noreferrer"
            data-testid="cases-cta-button"
            className="btn-primary"
          >
            Solicitar Orçamento
          </a>
        </div>
      </div>
    </section>
  );
}
